<template>
  <!-- container -->
  <div id="middleWrapM" class="container">
    <!-- sub title -->
    <div class="sub_tit_area invest01">
      <img :src="`${resources}img/img-top-sub-title8.jpg`" alt="" />
      <div class="tit_area">
        <div class="sub_tit">경영실적</div>
        <div class="sub_txt">빠르고 정확한 정보를 투명하게 공개합니다.</div>
      </div>
    </div>
    <!--// sub title -->

    <!-- sub contents -->
    <div class="sub_contents">
      <h3>주요 경영실적</h3>
      <div class="financial_ico">
        <ul>
          <li>
            <strong>매출액</strong>
            <p>
              <NumMotion :maxiMum="2884" :numSpeed="500" :numDelay="900" />억원
            </p>
          </li>
          <!-- <li>
            <strong>영업이익</strong>
            <p>
              <NumMotion :maxiMum="310" :numSpeed="700" :numDelay="1200" />억원
            </p>
          </li> -->
          <li>
            <strong>총 자산</strong>
            <p>
              <NumMotion :maxiMum="2166" :numSpeed="600" :numDelay="1500" />억원
            </p>
          </li>
        </ul>
      </div>

      <div class="flex_box2 mgt50">
        <h3>재무상태표</h3>
        <div class="txt_rht">(단위: 백만원)</div>
      </div>
      <div class="tbl_ty02 bod tbl_align_rht tbl_scroll">
        <table>
          <caption>
            재무상태표: 구분, 2023년, 2022년,
            2021년,자산총계,유동자산,비유동자산,부채총계,유동부채,비유동부채,자본총계로
            구성
          </caption>
          <thead>
            <tr>
              <th scope="col">구분</th>
              <th scope="col">2023년</th>
              <th scope="col">2022년</th>
              <th scope="col">2021년</th>
            </tr>
          </thead>
          <tbody>
            <tr class="tbl_bg">
              <td class="td_tit">자산총계</td>
              <td>216,643</td>
              <td>338,863</td>
              <td>313,724</td>
            </tr>
            <tr>
              <td class="td_tit">유동자산</td>
              <td>106,789</td>
              <td>236,015</td>
              <td>184,781</td>
            </tr>
            <tr>
              <td class="td_tit">비유동자산</td>
              <td>109,854</td>
              <td>102,878</td>
              <td>128,943</td>
            </tr>
            <tr class="tbl_bg">
              <td class="td_tit">부채총계</td>
              <td>112,691</td>
              <td>228,139</td>
              <td>194,122</td>
            </tr>
            <tr>
              <td class="td_tit">유동부채</td>
              <td>83,924</td>
              <td>185,709</td>
              <td>125,845</td>
            </tr>
            <tr>
              <td class="td_tit">비유동부채</td>
              <td>28,767</td>
              <td>42,430</td>
              <td>68,277</td>
            </tr>
            <tr class="tbl_bg">
              <td class="td_tit">자본총계</td>
              <td>103,952</td>
              <td>110,724</td>
              <td>119,602</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- <div class="flex_box2 mgt50">
        <h3>손익계산서</h3>
        <div class="txt_rht">(단위: 백만원)</div>
      </div>
      <div class="tbl_ty02 bod tbl_align_rht tbl_scroll">
        <table>
          <caption>
            손익계산서: 구분, 2022년, 2021년, 2020년, 매출, 매출총이익, 영업이익
            세전이익, 순이익으로 구성
          </caption>
          <thead>
            <tr>
              <th scope="col">구분</th>
              <th scope="col">2022년</th>
              <th scope="col">2021년</th>
              <th scope="col">2020년</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="td_tit">매출</td>
              <td>373,753</td>
              <td>394,380</td>
              <td>204,493</td>
            </tr>
            <tr>
              <td class="td_tit">매출총이익</td>
              <td>44,178</td>
              <td>41,254</td>
              <td>20,880</td>
            </tr>
            <tr>
              <td class="td_tit">영업이익</td>
              <td>30,995</td>
              <td>33,607</td>
              <td>12,736</td>
            </tr>
            <tr class="tbl_bg">
              <td class="td_tit">세전이익</td>
              <td>27,734</td>
              <td>33,028</td>
              <td>-28,080</td>
            </tr>
            <tr class="tbl_bg">
              <td class="td_tit">순이익</td>
              <td>21,064</td>
              <td>6,439</td>
              <td>-19,577</td>
            </tr>
          </tbody>
        </table>
      </div> -->
    </div>
    <!--// sub contents -->
  </div>
  <!--// container -->
</template>
<script>
import NumMotion from '@/components/TMain/NumMotion.vue';
import page from '@/mixins/page';

export default {
  mixins    : [page],
  components: {
    NumMotion
  }
};
</script>

<style lang="scss" scoped></style>
